import {useCallback, useEffect, useState} from "react";
import {getDashboard} from "../api/dashboardApiClient";

export const useDashboard = (reloadTrigger) => {
    const [statusCounts, setStatusCounts] = useState(null);
    const [levelCounts, setLevelCounts] = useState(null);
    const [customerLevelRequirements, setCustomerLevelRequirements] = useState(null);

    const fetchDashboard = useCallback(async () => {
        try {
            const data = await getDashboard();
            setStatusCounts(data.statusCounts);
            setLevelCounts(data.levelCounts);
            setCustomerLevelRequirements(data.customerLevelRequirements);
        }
        catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        fetchDashboard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchDashboard, reloadTrigger]);

    return {statusCounts : statusCounts, levelCounts : levelCounts, customerLevelRequirements : customerLevelRequirements};
};